import * as Factory from 'factory.ts'
import faker from 'faker'

import { OrderItemReceiveMethods, OrderItemTypes } from '@webapp/models/enums'
import { type PurchaseOrderLineItem } from '@webapp/models/PurchaseOrderLineItem'
import { SimpleUserMock } from '.'
import { CurrencyMock } from './currency.factory'
import { VendorMock } from './vendor.factory'

export const PurchaseOrderLineItemMock =
  Factory.Sync.makeFactory<PurchaseOrderLineItem>({
    currency: CurrencyMock.build({ name: 'CAD' }),
    date_required: Factory.each(() => faker.date.future().toISOString()),
    flags: [],
    line_comment: Factory.each(() => faker.lorem.sentence()),
    num: Factory.each(() => faker.random.number().toString()),
    orderNum: Factory.each(() => faker.random.number()),
    order_number: Factory.each(() => faker.random.number()),
    order_uuid: Factory.each(() => faker.random.uuid()),
    pref_vendor: Factory.each(() => {
      const { id, name, overall_score, email, contact } = VendorMock.build()

      return { id, name, overall_score, email, contact }
    }),
    price: Factory.each(() => faker.commerce.price()),
    purchaser: null,
    requester: Factory.each(() => {
      const { id, firstName, lastName } = SimpleUserMock.build()

      return { id, firstName, lastName }
    }),
    quantity: Factory.each(() => faker.random.number().toString()),
    unit: Factory.each(() => faker.commerce.productAdjective()),
    catalog_item: null,
    custom_fields: [],
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.commerce.productName()),
    recurrence: null,
    total_cost: Factory.each(() => faker.commerce.price()),
    type: OrderItemTypes.ONE_TIME,
    receive_method: OrderItemReceiveMethods.QUANTITY,
  }).withDerivation1(['pref_vendor'], 'vendor', (prefVendor) => {
    if (prefVendor.id === 1) {
      return VendorMock.build().name
    } else {
      return prefVendor.name
    }
  })
